import { useMemo } from 'react';
import { CHALLENGE_SESSION_STORAGE_KEYS } from '@services/cognito/constants';

const readSessionStorageItem = (key) => {
  try {
    return sessionStorage.getItem(key);
  } catch (_) {
    return null;
  }
};

const getMfaChallengeContext = (locationState) => {
  const usernameFromState = locationState?.username;
  const challengeNameFromState = locationState?.challengeName;
  const sessionFromState = locationState?.session;

  const username =
    usernameFromState || readSessionStorageItem(CHALLENGE_SESSION_STORAGE_KEYS.USERNAME);
  const challengeName =
    challengeNameFromState || readSessionStorageItem(CHALLENGE_SESSION_STORAGE_KEYS.CHALLENGE_NAME);

  let session = sessionFromState;
  if (!session) {
    const storedUsername = readSessionStorageItem(CHALLENGE_SESSION_STORAGE_KEYS.USERNAME);
    if (storedUsername && storedUsername === username) {
      session = readSessionStorageItem(CHALLENGE_SESSION_STORAGE_KEYS.SESSION);
    }
  }

  return {
    username,
    challengeName,
    session,
    deliveryMedium: locationState?.deliveryMedium,
    destination: locationState?.destination,
    shouldSyncPasswordChangedAt: Boolean(locationState?.shouldSyncPasswordChangedAt),
  };
};

export default function useMfaChallengeContext(locationState) {
  return useMemo(() => getMfaChallengeContext(locationState), [locationState]);
}
